import { ItemStrings } from './inventory'

export const Obstacles = {
    royal: {
        name: "Royal Insignia",
        icon: "royal.png",
        description: 'The royal insignia. Requires <img class="tooltipIcon" src="images/zeldas-lullaby.png" /> <i>Zelda\'s Lullaby</i> to activate.',
        item: ItemStrings.zeldasLullaby
    },
    ancient: {
        name: "Time Block",
        icon: "time-block.png",
        description: 'An ancient block. Requires the <img class="tooltipIcon" src="images/song-of-time.png" /> <i>Song of Time</i> to remove.',
        item: ItemStrings.songOfTime
    },
    boulder: {
        name: "Boulder",
        icon: "boulder.png",
        description: 'A large boulder. Requires <img class="tooltipIcon" src="images/bombs.png" /> <i>Bombs</i> to remove.',
        item: ItemStrings.bombs
    },
    illusion: {
        name: "Illusion",
        icon: "illusion.png",
        description: 'An illusion. Can be dispelled by the <img class="tooltipIcon" src="images/lens-of-truth.png" /> <i>Lens of Truth</i>.',
        item: ItemStrings.lensOfTruth
    },
    eyeSwitch: {
        name: "Eye Switch",
        icon: "eye-switch.png",
        description: 'A switch resembling an eye. Can be activated with the <img class="tooltipIcon" src="images/bow.png" /> <i>Bow</i>.',
        item: ItemStrings.bow
    },
    lava: {
        name: "Lava Path",
        icon: "lava.png",
        description: 'A path covered in lava. Requires the <img class="tooltipIcon" src="images/goron-tunic.png" /> <i>Goron Tunic</i> to traverse.',
        item: ItemStrings.goronTunic
    },
    underwater: {
        name: "Underwater Path",
        icon: "underwater.png",
        description: 'An underwater path. Requires the <img class="tooltipIcon" src="images/iron-boots.png" /> <i>Iron Boots</i> to traverse.',
        item: ItemStrings.ironBoots
    },
    void: {
        name: "Void",
        icon: "void.png",
        description: 'An empty void. Requires the <img class="tooltipIcon" src="images/hover-boots.png" /> <i>Hover Boots</i> to cross over.',
        item: ItemStrings.hoverBoots
    },
    hookPoint: {
        name: "Hook Target",
        icon: "hook-point.png",
        description: 'A hookshot target. Requires the <img class="tooltipIcon" src="images/hookshot.png" /> <i>Hookshot</i> to reach.',
        item: ItemStrings.hookshot
    },
    heavySwitch: {
        name: "Heavy Switch",
        icon: "switch.png",
        description: 'A large switch. Requires the <img class="tooltipIcon" src="images/hammer.png" /> <i>Megaton Hammer</i> to activate.',
        item: ItemStrings.hammer
    },
    sunSpot: {
        name: "Sun Pattern",
        icon: "sun-pattern.png",
        description: 'A switch resembling a sun. Requires <img class="tooltipIcon" src="images/mirror-shield.png" /> <i>Mirror Shield</i> to activate.',
        item: ItemStrings.mirrorShield
    },
    pillar: {
        name: "Giant Pillar",
        icon: "pillar.png",
        description: 'A massive pillar. Can be picked up with the <img class="tooltipIcon" src="images/silver-gauntlets.png" /> <i>Silver Gauntlets</i>.',
        item: ItemStrings.silverGauntlets
    }
}